export function prepareBelgiumBaseLayers(layers, country) {
  if (!['4', 'be'].includes(String(country).trim().toLowerCase())) return layers;
  const source = layer => String(layer.typeName || '').toLowerCase().split(':').pop();
  const isRegions = layer => ['be_regions', 'u101403viewgroupadrestype1'].includes(source(layer))
    || /^regions?$/i.test(String(layer.title || '').trim());
  const result = layers.filter(layer => !isRegions(layer)).map(layer => ({ ...layer }));
  const existing = layers.find(isRegions);
  const template = layers.find(layer => ['be_provinces', 'u101405viewgroupadrestype1'].includes(source(layer)))
    || layers.find(layer => ['be_country', 'u101393viewgroupadrestype1'].includes(source(layer)));
  const regions = {
    visible: false,
    style: template?.style, children: [], ...existing,
    title: 'Regions', typeName: 'geolinq:be_regions', minResolution: 8, maxResolution: 6
  };
  result.sort((a, b) => (Number(a.displayOrder) || 0) - (Number(b.displayOrder) || 0));
  const countryIndex = result.findIndex(layer => ['be_country', 'u101393viewgroupadrestype1'].includes(source(layer))
    || /^countries$/i.test(String(layer.title || '').trim()));
  result.splice(countryIndex < 0 ? result.length : countryIndex, 0, regions);
  const hierarchy = [
    ['be_full_address', 'u101234be_adres', 'addresses', 'address'],
    ['be_statistical_sectors', 'u101413viewgroupadrestype1', 'nis9'],
    ['be_4pp', 'u1014134viewgroupadrestype1', 'postalcode', 'postalcodes'],
    ['be_deelgemeenten', 'u1014136viewgroupadrestype1', 'submunicipalities', 'nis6'],
    ['be_municipalities', 'u101411viewgroupadrestype1', 'municipalities'],
    ['be_arrondissements', 'u101409viewgroupadrestype1', 'borough', 'boroughs'],
    ['be_provinces', 'u101405viewgroupadrestype1', 'provincies', 'provinces'],
    ['be_regions', 'regions'],
    ['be_country', 'u101393viewgroupadrestype1', 'countries', 'country']
  ];
  const rank = layer => {
    const title = String(layer.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const index = hierarchy.findIndex(keys => keys.includes(source(layer)) || keys.includes(title));
    return index < 0 ? hierarchy.length : index;
  };
  result.sort((a, b) => rank(a) - rank(b));
  return result.map((layer, displayOrder) => ({ ...layer, displayOrder }));
}
